<div class="wrapper col-sm-12">
    <kendo-expansionpanel [title]="pageTitle"
                          [subtitle]="'Total: ' + gridData.total"
                          [disabled]="false"
                          [expanded]="true">
        <div class="row">
            <div class="col-sm-8">
                <div class="row">
                    <div class="col-sm-4 border bg-light">
                        <h3>Primary Filters</h3>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Customer Status</label>
                                <kendo-multiselect [data]="customerStatusList"
                                                   [valuePrimitive]="true"
                                                   [textField]="'description'"
                                                   [valueField]="'customerStatusId'"
                                                   [popupSettings]="{ appendTo: 'component' }"
                                                   [(ngModel)]="customerStatusIDList">
                                </kendo-multiselect>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-end">
                                <button style="margin: 5px" class="btn btn-primary" [disabled]="utilService.isLoading" (click)="searchCustomers()">Search</button>
                                <button style="margin: 5px" class="btn btn-secondary" [disabled]="utilService.isLoading" (click)="resetFilters()">Reset Filters</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <h3>Secondary Filters</h3>
                        <form [formGroup]="customerListGroup">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col">
                                            <label class="fw-bold">City/State/Zip</label>
                                            <city-dropdown [parentForm]="customerListGroup" [ctrlName]="'cityControl'" [placeholder]="'City'" [isCityStateZip]="true"
                                                           (citySelected)="filtersChanged($event, 'city')" (cityBlurred)="checkEmptyCity($event)"></city-dropdown>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <label class="fw-bold">Miles</label>
                                            <kendo-numerictextbox [min]="0" [format]="'n0'" formControlName="distanceControl" (blur)="filtersChanged($event, 'distance')"></kendo-numerictextbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col">
                                            <label class="fw-bold">Initiative</label>
                                            <kendo-combobox [data]="initiatives"
                                                            [textField]="'title'"
                                                            [valueField]="'customerInitiativeID'"
                                                            [valuePrimitive]="true"
                                                            [allowCustom]="true"
                                                            placeholder="Select or Enter New"
                                                            formControlName="initiativeControl"
                                                            (selectionChange)="filtersChanged($event, 'initiative')">
                                            </kendo-combobox>
                                            <button type="button" class="btn btn-primary" (click)="addNewInitiative()">Create New Initiative</button>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="pageType == 'Accounts'">
                                        <div class="col">
                                            <label class="fw-bold">Tags</label>
                                            <br />
                                            <div class="bg-white overflow-overlay border rounded"
                                                 style="position:absolute;width:200px;z-index:2;"
                                                 (click)="isTagListFocus=true"
                                                 (mouseleave)="isTagListFocus=false"
                                                 [ngStyle]="isTagListFocus ? {'overflow':'overlay','height':'250px','max-height':'250px'} : {'overflow':'hidden','height':'42px'}">
                                                <span class="text-secondary k-float-right m-2"><i class="fas fa-sort-down fa-lg"></i></span>
                                                <div *ngIf="tagTypeList.length>0">
                                                    <div *ngFor="let tag of tagTypeList">
                                                        <span class="btn m-1 text-nowrap" [ngClass]="checkSelectedTagType(tag) ? 'btn-' + tag.colorClassName : 'btn-light'" (click)="toggleTagType(tag)">
                                                            <i class="fas fa-tag"></i>
                                                            {{tag.tagTypePrefix != null && tag.tagTypePrefix != '' ? tag.tagTypePrefix + ' | ' : ''}}
                                                            {{tag.tagTypeName}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col" *showRolesIf="'CRM Admin'">
                <div class="row" *ngIf="!isUpdateTeams">
                    <div class="col">
                        <button type="button" class="btn btn-sml btn-primary" (click)="isUpdateTeams=true">Update Teams</button>
                    </div>
                </div>
                <div class="row border bg-light m-1" *ngIf="isUpdateTeams">
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <h3>Filter and Update Results</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Team Type</label>
                                <kendo-dropdownlist [data]="customerTeamTypeList"
                                                    [textField]="'description'"
                                                    [valueField]="'customerTeamTypeID'"
                                                    [valuePrimitive]="true"
                                                    [(ngModel)]="customerTeamTypeID"
                                                    [defaultItem]="defaultTeamType"
                                                    (valueChange)="filterFromToEmployees()">
                                </kendo-dropdownlist>
                            </div>
                            <div class="col">
                                <label class="fw-bold">From Employee</label>
                                <kendo-dropdownlist [data]="fromEmployeeList"
                                                    [textField]="'fullName'"
                                                    [valueField]="'employeeId'"
                                                    [valuePrimitive]="true"
                                                    [(ngModel)]="selectedFromEmployeeID"
                                                    [defaultItem]="defaultEmployee"
                                                    (valueChange)="search()">
                                </kendo-dropdownlist>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Parent Code (starts with)</label>
                                <input type="text" [(ngModel)]="parentCodeFilter" (blur)="search()" class="form-control" />
                            </div>
                            <div class="col">
                                <label class="fw-bold">To Employee</label>
                                <kendo-dropdownlist [data]="toEmployeeList"
                                                    [textField]="'fullName'"
                                                    [valueField]="'employeeId'"
                                                    [valuePrimitive]="true"
                                                    [defaultItem]="defaultEmployee"
                                                    [(ngModel)]="selectedToEmployeeID">
                                </kendo-dropdownlist>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="fw-bold">Customer Code (starts with)</label>
                                <input type="text" [(ngModel)]="customerCodeFilter" (blur)="search()" class="form-control" />
                            </div>
                            <!--<div class="col">
        <label class="fw-bold">Country</label>
        <input type="text" [(ngModel)]="customerCountryFilter" class="form-control" (change)="filterCustomersForTeamUpdate()" />
    </div>-->
                            <div class="col text-end">
                                <button type="button" class="btn btn-primary" (click)="filterCustomersForTeamUpdate()">Filter Customers</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input type="checkbox" name="isSelectAllCustomers" id="isSelectAllCustomers" [(ngModel)]="isSelectAllCustomers" [checked]="isSelectAllCustomers" (click)="toggleCustomer(0)" style="cursor: pointer;margin: 10px; transform: scale(1.5);" />
                                <label for="isSelectAllCustomers">Select all (max 500)</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button type="button" class="btn btn-sml btn-primary" (click)="saveCustomerTeams()" [disabled]="selectedCustomers.length == 0 || customerTeamTypeID == 0 || selectedFromEmployeeID == 0 || selectedToEmployeeID == 0">Save Teams</button>
                                <button type="button" class="btn btn-sml btn-secondary m-2" (click)="cancel()">Cancel</button>
                            </div>
                            <div class="col">
                                <label class="fw-bold text-danger">Records selected: {{selectedCustomers.length}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="isEdit && (searchCustomer | json) != '{}'">
            <div class="col-sm-11">
                <kendo-expansionpanel [title]="searchCustomer.customerCode + ': ' + searchCustomer.customerName"
                                      [subtitle]="searchCustomer.address1 + ',' + searchCustomer.cityStateZip"
                                      [expanded]="true">
                    <kendo-tabstrip (tabSelect)="onTabSelect($event)">
                        <kendo-tabstrip-tab title="Profile" [selected]="true">
                            <ng-template kendoTabContent>
                                <div style="padding-right:15px;">
                                    <customer-form [customerID]="searchCustomer.customerID" [pageType]="'Customer List'" (customerSaved)="edit($event)"></customer-form>
                                </div>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab title="Assigned Employees">
                            <ng-template kendoTabContent>
                                <div class="content col-sm-6">
                                    <customer-team-assigned [customerID]="searchCustomer.customerID" [pageType]="'customer list'"></customer-team-assigned>
                                </div>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab title="Tags">
                            <ng-template kendoTabContent>
                                <div class="content col-sm-6">
                                    <tagmap-select [recordID]="searchCustomer.customerID" [recordTypeName]="'Customer'"></tagmap-select>
                                </div>
                            </ng-template>
                        </kendo-tabstrip-tab>
                        <kendo-tabstrip-tab title="Child Companies" *ngIf="searchCustomer.parent == 'Y'">
                            <ng-template kendoTabContent>
                                <customer-child-grid [parentCustomerID]="searchCustomer.customerID"></customer-child-grid>
                            </ng-template>
                        </kendo-tabstrip-tab>
                    </kendo-tabstrip>
                </kendo-expansionpanel>
            </div>
            <div class="col-sm-1">
                <button type="button" class="btn btn-secondary" title="Close" (click)="customerEditRefresh(searchCustomer.customerID)"><i class="fas fa-times"></i></button>
            </div>
        </div>
        <div class="row" *ngIf="isAdd">
            <div class="col-sm-6">
                <kendo-expansionpanel [title]="'Add New Customer'"
                                      [subtitle]=""
                                      [expanded]="true">
                    <customer-quick-add [customerType]="'lead'" (onRefreshCustomer)="customerAddSaved($event)" [isCRM]="true"></customer-quick-add>
                </kendo-expansionpanel>
            </div>
        </div>

        <div class="row">
            <div [ngClass]="isEditTeam ? 'col-sm-8' : 'col-sm-12'" *ngIf="!utilService.isLoading">
                <kendo-grid #customerListGrid
                            [data]="gridData"
                            [sort]="gridState.sort"
                            [skip]="gridState.skip"
                            [pageSize]="gridState.take"
                            [filter]="gridState.filter"
                            [sortable]="true"
                            [pageable]="{ pageSizes: pageSizes }"
                            [filterable]="true"
                            [resizable]="true"
                            (dataStateChange)="dataStateChange($event)">
                    <ng-template kendoGridToolbarTemplate>
                        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isAdd"><i class="fas fa-plus"></i></button>
                    </ng-template>
                    <kendo-grid-column title="Action" width="125" *showRolesIf="'Account Manager,Sales,Outside Sales,CRM Admin'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div *ngIf="!isUpdateTeams">
                                <button type="button" class="btn btn-sml btn-success m-1" title="Edit Profile" tabindex="-1" (click)="edit(dataItem.customerID)"><i class="fas fa-pencil-alt"></i></button>
                                <!--<button type="button" class="btn btn-sml btn-primary m-1" title="Manage Parent" tabindex="-1" (click)="edit(dataItem.customerID)"><i class="fas fa-user-tie"></i></button>-->
                                <button type="button" class="btn btn-sml btn-primary m-1" title="Manage Team" tabindex="-1" (click)="editTeam(dataItem.customerID)"><i class="fas fa-users"></i></button>
                            </div>
                            <div *ngIf="isUpdateTeams">
                                <input type="checkbox" (change)="toggleCustomer(dataItem.customerID)" [checked]="isCustomerSelected(dataItem.customerID)" style="cursor: pointer;margin: 10px; transform: scale(1.5);" />
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="customerName" title="Customer">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <a href="/#/customer-detail/{{dataItem.customerCode}}" target="_blank">{{dataItem.customerName}}</a>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="customerCode" title="Customer 3x3"></kendo-grid-column>
                    <kendo-grid-column field="address1" title="Address"></kendo-grid-column>
                    <kendo-grid-column field="cityName" title="City"></kendo-grid-column>
                    <kendo-grid-column field="stateAbbrev" title="ST"></kendo-grid-column>
                    <kendo-grid-column field="zip" title="Zip"></kendo-grid-column>
                    <kendo-grid-column field="customerStatus" title="Status"></kendo-grid-column>
                    <kendo-grid-column field="initiatives" title="Initiative"></kendo-grid-column>
                    <kendo-grid-column field="salesRepName" title="Sales Rep"></kendo-grid-column>
                    <kendo-grid-column field="opsRepName" title="Ops Rep"></kendo-grid-column>
                    <kendo-grid-column field="accountRepName" title="Account Rep"></kendo-grid-column>
                    <kendo-grid-column field="parentCustomerCode" title="Parent" *ngIf="pageType == 'Accounts'"></kendo-grid-column>
                    <kendo-grid-column field="maxActionDate" title="Last Action" *ngIf="pageType == 'Accounts'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div *ngIf="dataItem.maxActionDate != '0001-01-01T00:00:00'">
                                {{dataItem.maxActionDate | date: 'M/dd/yy HH:mm'}}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="maxActionEmployeeName" title="Last Action By" *ngIf="pageType == 'Accounts'"></kendo-grid-column>
                    <kendo-grid-column field="parentMaxActionDate" title="Parent Last Action" *ngIf="pageType == 'Accounts'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div *ngIf="dataItem.parentMaxActionDate != '0001-01-01T00:00:00'">
                                {{dataItem.parentMaxActionDate | date: 'M/dd/yy HH:mm'}}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="parentMaxActionEmployeeName" title="Parent Last Action By" *ngIf="pageType == 'Accounts'"></kendo-grid-column>
                    <kendo-grid-column field="lastShipDate" title="Last Ship" *ngIf="pageType == 'Accounts'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div *ngIf="dataItem.lastShipDate != '0001-01-01T00:00:00'">
                                {{dataItem.lastShipDate | date: 'M/dd/yy'}}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="lastCompletedStopDate" title="Last Completed Stop" *ngIf="pageType == 'Accounts'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div *ngIf="dataItem.lastCompletedStopDate != '0001-01-01T00:00:00'">
                                {{dataItem.lastCompletedStopDate | date: 'M/dd/yy'}}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="industry" title="Industry"></kendo-grid-column>
                    <kendo-grid-column field="freightSpend" title="Freight Spend">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.freightSpend | currency : 'USD' : 'symbol' : '1.0-0'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="Tags" *ngIf="pageType == 'Accounts'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span *ngFor="let tag of getTagTypes(dataItem.tagTypes)">
                                <tagtype-tag [tag]="tag"></tagtype-tag>
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="activeInd" title="Active" filter="boolean" *ngIf="pageType == 'Accounts'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.activeInd ? 'Yes': 'No'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="retiredInd" title="Retired" filter="boolean" *ngIf="pageType == 'Accounts'">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.retiredInd ? 'Yes': 'No'}}
                        </ng-template>
                    </kendo-grid-column>
                    <!--<kendo-grid-column field="stopCount" title="Stops" *ngIf="pageType == 'Accounts'"></kendo-grid-column>-->
                </kendo-grid>
            </div>
            <div class="col-sm-4" *ngIf="isEditTeam">
                <div class="row">
                    <div class="col-sm-10">
                        <customer-team-assigned [customerID]="customerID" [pageType]="'customer list'"></customer-team-assigned>
                    </div>
                    <div class="col-sm-2">
                        <button type="button" class="btn btn-secondary" title="Close" (click)="customerTeamRefresh()"><i class="fas fa-times"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </kendo-expansionpanel>
</div>
